module.exports = __webpack_public_path__ + "img/advantage_01.291cc2e2.png";